class DeviceChecker {
  private static instance: DeviceChecker;
  private readonly isAppleDevice: boolean;

  private constructor() {
    // Detect iOS or macOS based on user agent
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;

    this.isAppleDevice = /Macintosh|MacIntel|MacPPC|Mac68K|iPhone|iPad|iPod/i.test(
      userAgent
    );
  }

  public static getInstance(): DeviceChecker {
    if (!DeviceChecker.instance) {
      DeviceChecker.instance = new DeviceChecker();
    }
    return DeviceChecker.instance;
  }

  public checkIsAppleDevice(): boolean {
    return this.isAppleDevice;
  }
}

export default DeviceChecker;
